import DraggableCard from './DraggableCard.component';

export default DraggableCard;
